import { useState } from "react";

// COMPONENTS
import ContainerScreen from "@/main/components/shared/containerScreen/containerLayout";

// SERVICES / REDUX / UTILS
import { IntegrationQueueRequest } from "@/main/models/request";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { IntegrationQueueResponse } from "@/main/models/response";
import { getTranslateByKey } from "@/main/services/utils";

// SCREENS/COMPONENTS/CONTEXT LOCAL
import GridIntegration from "./gridIntegration/gridIntegration";
import FiltersIntegration from "./filtersIntegration/filtersIntegration";
import { withQueryparams } from "@/main/components/core/queryParams/queryparams";

function IntegrationQueueScreen() {
	const [dataGrid, setDataGrid] = useState<IntegrationQueueResponse[]>([]);
	const [formFilters, setFormFilters] = useState<IntegrationQueueRequest | null>(null);

	function onResetSearch() {
		setDataGrid([]);
		setFormFilters(null);
	}

	async function getDataIntegrationQueue(
		filters: IntegrationQueueRequest | Partial<IntegrationQueueRequest> = {},
		isResetSearch: boolean = true,
	) {
		const request: IntegrationQueueRequest = {
			...(isResetSearch ? {} : formFilters),
			...(filters as IntegrationQueueRequest),
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize10,
		};

		onResetSearch();
		setFormFilters(request);
	}

	const titlePage = `${getTranslateByKey("module.integration")} > ${getTranslateByKey("screen.integrationqueue")}`;

	return (
		<ContainerScreen hasBackground title={titlePage}>
			<FiltersIntegration onResetSearch={onResetSearch} getDataIntegrationQueue={getDataIntegrationQueue} />
			<GridIntegration
				formFilters={formFilters}
				dataGrid={dataGrid}
				setDataGrid={setDataGrid}
				getDataIntegrationQueue={getDataIntegrationQueue}
			/>
		</ContainerScreen>
	);
}

export default withQueryparams(IntegrationQueueScreen);
